import { matchPath, useLocation } from "react-router-dom";
import { ROUTES } from "@/constants";

type ApplicationRouteType = "application" | "quote";

const routePath = (path: string) => `/${path}`;

const useApplicationRouteType = (): ApplicationRouteType => {
  const { pathname } = useLocation();

  if (matchPath({ path: routePath(ROUTES.APP.QUOTE_DETAIL), end: true }, pathname)) {
    return "quote";
  }

  if (matchPath({ path: routePath(ROUTES.APP.APPLICATION_DETAIL), end: true }, pathname)) {
    return "application";
  }

  return "application";
};

export { useApplicationRouteType };
export type { ApplicationRouteType };
